import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

import {PageHero, PageShell, PageTitle, Section} from 'components';

import qrcode from './assets/qrcode.jpeg';
import serviceImg from './assets/service.jpg';

/**
 * 联系我们（v3）：二维码卡 + 客服联系方式。
 * 原两段式（AboutUsHero/AboutUsValue 子组件复制自 AboutUs 模板）合并为单文件，
 * 排版走 v3 骨架；文案沿用 about 词典 contact 命名空间。
 */

const ContactUs: FC = () => {
  const {t} = useTranslation('about');

  /** 客服信息条目：label + 值（微信号/电话/邮箱为可直接联系的渠道，置前） */
  const contactRows: {key: string; label: string; value: string}[] = [
    {key: 'wechat', label: t('contact.value.wechatLabel'), value: 'xiangjifanyi'},
    {key: 'phone', label: t('contact.value.phoneLabel'), value: '17664075341'},
    {key: 'email', label: t('contact.value.emailLabel'), value: 'bussiness@tosoiot.com'},
    {key: 'company', label: t('contact.value.companyLabel'), value: t('contact.value.companyName')},
    {key: 'suzhou', label: t('contact.value.suzhouHqLabel'), value: t('contact.value.suzhouAddress')},
    {key: 'shanghai', label: t('contact.value.officeAddressLabel'), value: t('contact.value.shanghaiAddress')},
  ];

  return (
    <PageShell>
      <PageTitle canonicalUrl="https://www.xiangjifanyi.com/home/contact-cn" title={t('contact.pageTitle')} />
      <PageHero
        aside={
          <div className="glass-card rounded-3xl p-7 lg:p-9 max-w-sm w-full mx-auto text-center">
            <img alt={t('contact.hero.wechatAccount')} className="w-full rounded-xl" decoding="async" src={qrcode} />
            <p className="text-sm lg:text-base text-slate-600 mt-5">{t('contact.hero.wechatAccount')}</p>
          </div>
        }
        badge={t('contact.heading')}
        description={
          <>
            {t('contact.hero.scanTip')}
            <br />
            {t('contact.hours')}
          </>
        }
        title={t('contact.hero.title')}
        variant="light"
      />
      <Section bg="muted" title={t('contact.value.serviceTitle')}>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <img
            alt={t('contact.value.serviceTitle')}
            className="w-full rounded-2xl shadow-xl"
            decoding="async"
            loading="lazy"
            src={serviceImg}
          />
          <div className="grid sm:grid-cols-2 gap-5">
            {contactRows.map((row) => (
              <div className="bg-white rounded-2xl p-6 shadow-sm" key={row.key}>
                <p className="text-sm text-slate-500 mb-1.5">{row.label}</p>
                <p className="text-sm lg:text-base font-medium text-slate-900 break-all">{row.value}</p>
              </div>
            ))}
          </div>
        </div>
      </Section>
    </PageShell>
  );
};

export default ContactUs;
